export const CancellationSurveyEnum: { id: number; reason: string }[] = [
  {
    id: 1,
    reason: 'The membership is too expensive'
  },
  {
    id: 2,
    reason: 'I’ve achieved my learning goals'
  },
  {
    id: 3,
    reason: 'I’m not interested in learning poker anymore'
  },
  {
    id: 4,
    reason:
      'I’m not developing any life skills (e.g., strategic thinking, risk management, confidence, decision-making)'
  },
  {
    id: 5,
    reason: 'I’m not connecting with the community'
  },
  {
    id: 6,
    reason: 'I’m not using the premium features'
  },
  {
    id: 7,
    reason: 'Not enough premium features'
  },
  {
    id: 8,
    reason: 'Other'
  }
]
